module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage"
  }, [_c('a', {
    attrs: {
      "id": "title47"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-c-br"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("To my much-loved friends in New Orleans and"), _c('br'), _vm._v(" southeast Louisiana, who’ve endured so much and yet"), _c('br'), _vm._v(" live so large, no matter what life throws your way")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b53885d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429988476_ded01.vue
// module id = 66
// module chunks = 0